import { render } from "./SourceListItem.vue?vue&type=template&id=23f345aa&scoped=true"
import script from "./SourceListItem.vue?vue&type=script&lang=js"
export * from "./SourceListItem.vue?vue&type=script&lang=js"

import "./SourceListItem.vue?vue&type=style&index=0&id=23f345aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f345aa"]])

export default __exports__